import { render } from "./Unverified.vue?vue&type=template&id=2553515c"
import script from "./Unverified.vue?vue&type=script&lang=js"
export * from "./Unverified.vue?vue&type=script&lang=js"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__